import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import styled from "styled-components";
import AttendeesModal from "../../components/Events/AttendeesModal";
import EventsHeader from "../../components/Events/EventsHeader";
import EventsTable from "../../components/Events/EventsTable";
import Modal from "../../components/Modal";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import { Text } from "../../config/Constants";
import {
  fetchAllEvents,
  fetchAttendessDetails,
} from "../../services/eventsService";

const Events = () => {
  const LIMIT = 10;
  const [data, setData] = useState<any>([]);
  const navigate = useNavigate();
  const [totalEvents, setTotalEvents] = useState(0);
  const [query, setQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isFailureModal, setIsFailureModal] = useState(false);
  const [isTableDataLoading, setTableLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    heading: "",
    subHeading: "",
  });
  const [attendeesModal, setAttendeesModal] = useState(false);
  const [attendeesDetails, setAttendeesDetails] = useState<any>({});

  useEffect(() => {
    fetchEvents(currentPage, LIMIT, query);
  }, [currentPage, query]);

  const fetchEvents = async (
    activePage: number,
    limitCount: number,
    queryString: string
  ) => {
    setTableLoader(true);
    try {
      let { data } = await fetchAllEvents(activePage, limitCount, queryString);
      if (data.code === 200) {
        setTableLoader(false);
        setTotalEvents(data.count);
        setData(data.data);
      }
    } catch (error: any) {
      setTableLoader(false);
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: Text.somethingWentWrong,
          subHeading: error.message,
        });
      }
    }
  };

  const fetchAttendees = async (id: string) => {
    try {
      let { data } = await fetchAttendessDetails(id);
      setAttendeesDetails((prevState: {}) => ({ ...prevState, ...data.data }));
      setAttendeesModal(true);
    } catch (error: any) {}
  };

  const handleSearch = (value: string) => {
    setQuery(value);
    setCurrentPage(1);
    fetchEvents(1, LIMIT, value);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    fetchEvents(page, LIMIT, query);
  };

  const handleEdit = (id: string) => {
    navigate(`/admin/edit-event/${id}`);
  };

  const showAttendees = (event: any) => {
    setAttendeesDetails({
      eventTitle: event.title,
    });
    fetchAttendees(event._id);
  };

  return (
    <EventsPageContainer>
      <EventsHeader onSearch={handleSearch} query={query} />
      <EventsTable
        onPageChange={(page) => handlePageChange(page)}
        totalData={totalEvents}
        currentPage={currentPage}
        rowsPerPage={LIMIT}
        data={data}
        isTableDataLoading={isTableDataLoading}
        onEdit={handleEdit}
        showAttendees={showAttendees}
      />
      {attendeesModal && (
        <Modal
          setOpenOrClose={setAttendeesModal}
          variant="none"
          width="23rem"
        >
          <AttendeesModal
            setOpenOrClose={setAttendeesModal}
            attendeesDetails={attendeesDetails}
          />
        </Modal>
      )}
      {isFailureModal && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.heading}
          subHeading={errorMessage.subHeading}
          buttonLabel={Text.okButton}
          setOpenOrClose={setIsFailureModal}
          onSubmit={() => setIsFailureModal(false)}
        />
      )}
    </EventsPageContainer>
  );
};

const EventsPageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default Events;
